import gql from 'graphql-tag';

import type { SubTemplate } from 'src/data/template';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query SubTemplates {
    subTemplates {
      id
      name
      description
      generationTool
      tags
      questions {
        question
        mandatory
        placeholder
      }
    }
  }
`;

export const querySubTemplates = async () => {
  const result = await executeGqlQuery({
    query: QUERY,
  });

  return getSingleProp<SubTemplate[]>(result.data) || [];
};
